import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharingService } from './shared/services/dataSharing.services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppComponent } from './app.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppLoaderService } from './shared/services/app-loader.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  entryComponents: [
  ],
  imports: [
            BrowserModule,
            IonicModule.forRoot(),
            AppRoutingModule,
            HttpClientModule,
            RouterModule,
            FormsModule,
            ReactiveFormsModule,
            BrowserAnimationsModule,
            MatButtonModule,
            MatIconModule,
            MatSnackBarModule
          ],
  providers: [
    {
    provide: RouteReuseStrategy,
    useClass: IonicRouteStrategy
    },
    {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
    },
    { provide: LOCALE_ID, useValue: "it-IT" },
    SharingService,
    AppLoaderService
  ],
  bootstrap: [AppComponent],
  
})
export class AppModule {}
